import React, { Component } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import moment from "moment";
import {
  Avatar,
  Button,
  CssBaseline,
  TextField,
  Grid,
  Typography,
  CircularProgress,
  Container,
} from "@mui/material";
import { QueuePlayNext } from "@mui/icons-material";
import { withStyles } from "@mui/styles";
import { Styles } from "../../styles/material-styles";
import { Overlay } from "../../styles/global";
import Api from "../../services/api";
import CustomizedSnackbars from "../../components/material-snackbars";
import HeaderMenu from "../../components/header-menu";
import { connect } from "react-redux";
import { browserHistory } from "../../helpers/history";
import { FormattedMessage, injectIntl } from "react-intl";
import Title from "../../components/title-name";
import * as componentActions from "../../redux/actions/breakreasons";
import { PapiroConsole } from "../../utils/papiroConsole";
import * as ParamsService from "../../services/2talk/chatbotResponseParams.service.js";

class BreakReasonEdit extends Component {
  constructor(props) {
    super(props);
    const { userSession, breakreasons } = this.props;

    PapiroConsole.log("Props de breakreasons --->");
    PapiroConsole.log(this.props);

    this.fromProps = false;
    if (
      this.props &&
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.from &&
      this.props.location.state.from.length > 0
    )
      this.fromProps = true;

    this.globalAdm = false;
    this.isClient = true;
    if (userSession.user.userrole == null) {
      Api.logoff();
    }

    if (!breakreasons || (breakreasons && !breakreasons.breakreasons)) {
      var l = this.props.match.params.lang;
      document.location.href = `/${l}/calleds`;
    }

    userSession.user.userrole.map((item, key) => {
      if (item.role.roletype != 3) {
        this.isClient = false;
      }
      if (item.role.roletype == 0) {
        this.globalAdm = true;
      }
    });

    this.initialState = {
      UpdatedUser: userSession.user.id,
      id: breakreasons.breakreasons.id,
      name: breakreasons.breakreasons.name ?? "",
      breaklimit: breakreasons.breakreasons.breaklimit ?? "",
      issystem: breakreasons.breakreasons.system ? breakreasons.breakreasons.system : false,
    };

    this.state = {
      breakreasons: this.initialState,
      files: [],
      loading: false,
      openNotification: false,
      notificationVariant: "error",
      notificationMessage: "",
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.closeNotification = this.closeNotification.bind(this);
    this.changeValues = this.changeValues.bind(this);
  }

  async componentDidMount() {
    await this.getData();
  }

  getData = async () => {
    const intl = this.props.intl;
    this.setState({ loading: true });

    Api.get(`/break-reason/${this.state.breakreasons.id}`)
      .then((result) => {
        if (result.data.success) {
          this.setState({
            loading: false,
            breakreasons: {
              ...this.state.breakreasons,
            },
          });
        } else {
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: "error",
            notificationMessage:
              result.data && result.data.errors
                ? result.data.errors[0]
                : intl.formatMessage({ id: "process.error" }),
          });
          Api.kickoff(result);
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.errors) {
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: "error",
            notificationMessage:
              err.response && err.response.data && err.response.data.errors
                ? err.response.data.errors[0]
                : intl.formatMessage({ id: "process.error" }),
          });
        } else {
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: "error",
            notificationMessage:
              err.response && err.response.data.errors
                ? err.response.data.errors[0]
                : intl.formatMessage({ id: "process.error" }),
          });
        }
      });
  };

  handleInputChange(e) {
    const name = e.target.name;
    const value = e.target.value;

    this.setState((prevState) => ({
      breakreasons: {
        ...prevState.breakreasons,
        [name]: value,
      },
    }));
  }

  handleSubmit = async (e) => {
    e.preventDefault();

    this.setState({ loading: true });

    let data = new FormData();

    for (let key in this.state.breakreasons) {
      if (
        key.toString().toLowerCase().indexOf("_date") > -1 ||
        key.toString().toLowerCase().indexOf("date_") > -1
      ) {
        data.append(
          key,
          moment(this.state.breakreasons[key]).format("YYYY/MM/DD HH:mm:ss")
        );
      } else {
        data.append(key, this.state.breakreasons[key]);
      }
    }

    let config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    Api.put("/break-reason", data, config)

      .then((result) => {
        const intl = this.props.intl;
        if (result.data.success) {
          const intl = this.props.intl;
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: "success",
            notificationMessage: intl.formatMessage({ id: "edit.success" }),
          });
        } else {
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: "error",
            notificationMessage:
              result.data.errors && result.data.errors[0]
                ? result.data.errors[0]
                : this.props.intl.formatMessage({ id: "process.error" }),
          });
        }
      })
      .catch((err) => {
        const intl = this.props.intl;
        if (err.response && err.response.data && err.response.data.errors) {
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: "error",
            notificationMessage:
              err.response && err.response.data && err.response.data.errors
                ? err.response.data.errors[0]
                : this.props.intl.formatMessage({ id: "process.error" }),
          });
        } else {
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: "error",
            notificationMessage: err.response.data.errors
              ? err.response.data.errors[0]
              : this.props.intl.formatMessage({ id: "process.error" }) +
              err.response.data,
          });
        }
      });
  };

  closeNotification() {
    this.setState({ openNotification: false });
  }

  changeValues(stateName, value) {
    this.setState({ loading: true });

    this.setState((prevState) => ({
      breakreasons: {
        ...prevState.breakreasons,
      },
    }));

    this.setState({ loading: false });
  }

  handleChangeEditor(value, name) {
    this.setState((prevState) => ({
      breakreasons: {
        ...prevState.breakreasons,
        [name]: value || "",
      },
    }));
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props;
    const { breakreasons } = this.state;
    const intl = this.props.intl;

    if (Api == null) {
      var l = this.props.match.params.lang;
      document.location.href = `/${l}/unavailable`;
    }

    const isSystem = ParamsService.checkParamIsSystem(breakreasons);

    return (
      <div className={classes.root}>
        <HeaderMenu />
        <main
          className={clsx(
            classes.content,
            {
              [classes.contentShift]: headerMenu.open,
            },
            classes.actionsContent,
            {
              [classes.actionscontentShift]: actionsHeaderMenu.open,
            }
          )}
        >
          <div className={classes.drawerHeader} />

          <Container component="main" maxWidth="md">
            <CssBaseline />
            <div className={classes.paper} style={{ marginTop: 0 }}>
              <Grid container spacing={6}>
                <Grid item xs={12} sm={4}>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      browserHistory.goBack();
                    }}
                  >
                    {this.props.intl.formatMessage({ id: "back" })}
                  </Button>
                </Grid>
                <Grid item xs={12} sm={8} />
              </Grid>
              <Avatar className={classes.avatar}>
                <QueuePlayNext />
              </Avatar>
              <Typography component="h1" variant="h5">
                {<FormattedMessage id="edit.item" />}
                <Title />
              </Typography>
              <form
                name="myForm"
                className={classes.form}
                onSubmit={this.handleSubmit}
                encType="multipart/form-data"
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      inputProps={{ maxLength: 255 }}
                      fullWidth
                      label={intl.formatMessage({ id: "name" })}
                      autoComplete="fname"
                      variant="outlined"
                      name="name"
                      onChange={this.handleInputChange}
                      value={breakreasons.name}
                      required
                      disabled={isSystem}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      type="time"
                      inputProps={{ maxLength: 250, step: 1 }}
                      fullWidth
                      label={intl.formatMessage({ id: "break.limit" })}
                      autoComplete="fname"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      name="breaklimit"
                      onChange={this.handleInputChange}
                      value={breakreasons.breaklimit}
                      required
                      disabled={isSystem}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    style={{
                      marginTop: 15,
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: 15,
                    }}
                  >
                    <Grid
                      container
                      justify="flex-end"
                      style={{ justifyContent: "flex-end" }}
                    >
                      <Grid item xs={12} sm={4}>
                        <Button
                          type="submit"
                          fullWidth
                          variant="contained"
                          color="primary"
                          className={classes.submit}
                          disabled={isSystem}
                        >
                          {<FormattedMessage id="save" />}
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </form>
            </div>

            {this.state.loading && (
              <Overlay>
                <CircularProgress color="secondary" />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification}
            />
          </Container>
        </main>
      </div>
    );
  }
}

BreakReasonEdit.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession,
  breakreasons: state.breakreasons,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(componentActions, dispatch);

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(Styles)(BreakReasonEdit))
);
